export default {
  'datasets.placeholder': 'Search dataset name, task type, label type, organization name',
  'datasets.datasetsNum': '  {num} Datasets',
  'datasets.datasetsSearch': '{num} Datasets results for {name}',
  'datasets.title': 'Welcome to OpenDataLab',
  'datasets.describe':
    'OpenDataLab is a pioneering open data platform for the large AI model era, making datasets  accessible.',

  'datasets.filtering': 'Filtering',
  'datasets.more.filtering': 'More Filtering',

  'datasets.aside.modality': 'Data type',
  'datasets.aside.labelling': 'Label type',
  'datasets.aside.task': 'Task type',

  'datasets.formattedDesc': 'This dataset has been converted to a standardized format with the code provided.',
  'datasets.formattedClick': 'View detailed documentation',

  'datasets.noData': 'No Datasets',
  'datasets.noDataV2': 'No matching datasets found',

  // v1.6
  'datasets.hottest': 'Hottest',
  'datasets.hottestDownloadWeek': 'Weekly Hottest',
  'datasets.newest': 'Newest',
  'datasets.backTagList': 'Back to tag list',
  'datasets.list.newest': 'Recent Updates',
  'datasets.list.all': 'Default',
  'datasets.list.all.pc': 'Default',
  'datasets.list.views': 'Views',
  'datasets.list.viewsWeek': 'Weekly Views',

  // 1.7.1
  'datasets.searchTag': 'Search tags',
  'datasets.noResult': 'No results',
  'datasets.recently': 'Recently viewed',
  'datasets.name': 'Dataset name',
  'datasets.dataFilter': 'Data filtering',

  // xlab 2023/2/20
  'datasets.center': 'OpenDataLab',
  'datasets.explore': 'Provides high-quality open datasets for domestic massive  models!',
  'datasets.suBtitle': 'OpenDataLab provides high-quality open datasets for large models',
  'datasets.createYourDataset': 'Create your dataset now',
  'datasets.createDataset': 'Create Dataset',
  'datasets.shareDataset': 'Explore more quality datasets!',
  'datasets.repo': 'Repository',
  'datasets.repoRule': 'Please enter English, numbers or characters -',
  'datasets.repoExample': 'Example COCO2017, cannot be changed once created',
  'datasets.repoRule1': 'Please enter the repository name',
  'datasets.repoRule2': 'Cannot be pure numbers',
  'datasets.repoDesc': 'The unique index for viewing and using the dataset, which cannot be changed after creation',
  'datasets.createName': 'Name',
  'datasets.createNameRule': '', //不需要限制了
  'datasets.createNameDesc': 'Used for display',
  'datasets.cover': 'Dataset cover',
  'datasets.uploadDesc':
    'Cover size: 125*125; support uploading images in PNG, JPG, JPEG, and GIF formats, with a size of up to 5M',
  'datasets.desc': 'Dataset description',
  'datasets.immediateCreate': 'Create now',

  'datasets.FileNum': 'Total files: {num} ',
  'datasets.FilePage': ' Page {num} ',
  'datasets.create.publicDesc': "Files in the public dataset should comply with the platform's specifications.",
  'datasets.create.privateDesc':
    'Private datasets are only visible to the individual and are not open to other platform users; they can still be made public after creation',

  // Data upload
  'private.uploadData': 'Data upload',
  'private.selectFile': 'Select file',
  'private.selectFolder': 'Select folder',
  'private.selectArchive': 'Select archive',
  'private.uploadCover': 'Upload Cover',
  'private.archiveHint':
    'Files uploaded in compressed packages will be automatically decompressed, and the original compressed files will still be retained',
  'private.uploadDesc':
    'Web upload restrictions "Single file ≤ 4GB, total size ≤ 50GB, total number ≤ 10000, compressed package only support zip", CLI/SDK side unlimited.',
  'private.coverErrSpec': 'Please upload a cover image that meets the format',
  'private.coverErrSensitive': 'Cover image sensitive, please modify and try again',
  'private.readCount': 'A total of {count} files read',
  'private.uploadNow': 'Upload now',
  'private.fileSizeErr': 'Single file size exceeds 4GB',
  'private.allFileSizeErr': 'Total file size exceeds 50GB',
  'private.allFileCountErr': 'Total number of files exceeds 10000',
  'private.fileTypeErr': 'Incorrect file type',
  'private.exitUpload': 'Confirm to exit data upload?',
  'private.exitUploadHint': 'Transmitted data will not be saved?',
  'private.uploadSpec': 'Upload specifications: 5M or less png, jpg, jpeg, gif format images are supported',
  'private.uploadMethods': 'Upload method',
  'private.uploadLocal': 'Local Upload',
  'private.uploadGithub': 'GitHub Repo Import',
  'private.uploadUrl': 'URL Import',
  'private.uploadUrl.tip': 'URL: 1 file only, max 5GB. Use CLI/SDK for larger files',
  'private.uploadUrl.withoutSize': 'Upload in progress.... URL lacks file size, cannot display real-time progress  ',
  'private.uploadUrl.placeholder': 'Please enter the data file URL',
  'private.import': 'Import',
  'private.uploadUrl.alreadyAdded': 'URL already added',
  'private.uploadUrl.inValid': 'Invalid URL',
  'private.uploadUrl.authUrl': 'Please add the correct URL file',
  // github上传
  'private.githubUpload.title': 'Github Repo',
  'private.githubUpload.placeholder':
    'Please provide the repository URL and branch/tag information to automatically retrieve.',
  'private.githubUpload.input.user': 'Use',
  'private.githubUpload.input.reading': 'Reading...',
  'private.githubUpload.input.Rereading': 'Rereading',
  'private.githubUpload.require.error': 'Please enter the correct github link',
  'private.githubUpload.repo.not.exist': 'The repository does not exist',
  'private.githubUpload.authorized': 'GitHub account authorization',
  'private.githubUpload.repo.require.authorized': 'Please complete',
  'private.githubUpload.selectBranch': 'Please select a branch or tag',

  // Task list
  'private.taskList': 'Task list',
  'private.uploadList': 'Upload list',
  'private.unpackList': 'Unpack list',
  'private.upload.prompt':
    'Refreshing or closing the browser will cancel the current local upload task and clear the record.',
  'private.upload.all': 'All',
  'private.uploading': 'Uploading',
  'private.uploadSuccess': 'Upload success',
  'private.uploadError': 'Upload failed',
  'private.unpacking': 'Unpacking',
  // Waiting
  'private.waiting': 'Waiting',
  'private.unpackSuccess': 'Unpack success',
  'private.unpackError': 'Unpack failed',
  'private.unpackTime': 'Unpack time',
  'private.reUpload': 'Re-upload',
  'private.reUnpack': 'Re-unpack',

  // success
  'private.success.datasetCreate': 'Dataset created successfully',
  'private.success.datasetUpdate': 'Dataset updated successfully',
  'private.success.returnDetail': 'Return to details page',
  'private.success.upload': 'Upload data',

  // mobile
  'datasets.mobile.placeholder': 'Search for datasets',
  'datasets.mobile.datasetsNum': '{num} Datasets',

  'datasets.search': 'Search History',
  'datasets.hotRecommend': 'Hot Searches'
};
